// ──────────────────────────────────────────────────────────────────────────
//  Codice Fiscale Utilities – decodifica e validazione
//  100% client-side, nessuna API esterna, completamente gratuito
// ──────────────────────────────────────────────────────────────────────────

const MESI = {
  A: "Gennaio",
  B: "Febbraio",
  C: "Marzo",
  D: "Aprile",
  E: "Maggio",
  H: "Giugno",
  L: "Luglio",
  M: "Agosto",
  P: "Settembre",
  R: "Ottobre",
  S: "Novembre",
  T: "Dicembre",
};

// Tabella valori per caratteri in posizione dispari (0-indexed pari)
const ODD_VALUES = {
  0: 1,
  1: 0,
  2: 5,
  3: 7,
  4: 9,
  5: 13,
  6: 15,
  7: 17,
  8: 19,
  9: 21,
  A: 1,
  B: 0,
  C: 5,
  D: 7,
  E: 9,
  F: 13,
  G: 15,
  H: 17,
  I: 19,
  J: 21,
  K: 2,
  L: 4,
  M: 18,
  N: 20,
  O: 11,
  P: 3,
  Q: 6,
  R: 8,
  S: 12,
  T: 14,
  U: 16,
  V: 10,
  W: 22,
  X: 25,
  Y: 24,
  Z: 23,
};

// Tabella valori per caratteri in posizione pari (0-indexed dispari)
const EVEN_VALUES = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
};

// ──────────────────────────────────────────────────────────────────────────
//  Comuni italiani – codice Belfiore
// ──────────────────────────────────────────────────────────────────────────
const COMUNI = {
  A089: "Agrigento",
  A182: "Alessandria",
  A271: "Ancona",
  A326: "Aosta",
  A345: "L'Aquila",
  A390: "Arezzo",
  A462: "Ascoli Piceno",
  A479: "Asti",
  A509: "Avellino",
  A596: "Bagnacavallo (RA)",
  A662: "Bari",
  A757: "Belluno",
  A783: "Benevento",
  A794: "Bergamo",
  A859: "Biella",
  A944: "Bologna",
  B157: "Brescia",
  B160: "Bolzano / Bozen",
  B180: "Brindisi",
  B354: "Cagliari",
  B429: "Caltanissetta",
  B519: "Campobasso",
  B963: "Caserta",
  C351: "Catania",
  C352: "Catanzaro",
  C632: "Chieti",
  C933: "Como",
  D086: "Cosenza",
  D122: "Crotone",
  D150: "Cremona",
  D205: "Cuneo",
  D542: "Fermo",
  D548: "Ferrara",
  D612: "Firenze",
  D643: "Foggia",
  D704: "Forlì",
  D810: "Frosinone",
  D969: "Genova",
  E098: "Gorizia",
  E169: "Grosseto",
  E290: "Imperia",
  E335: "Isernia",
  E372: "Jesi (AN)",
  E463: "La Spezia",
  E472: "Latina",
  E506: "Lecce",
  E507: "Lecco",
  E625: "Livorno",
  E648: "Lodi",
  E715: "Lucca",
  E783: "Macerata",
  E897: "Mantova",
  F023: "Massa",
  F052: "Matera",
  F158: "Messina",
  F205: "Milano",
  F257: "Modena",
  F704: "Monza",
  F839: "Napoli",
  F952: "Novara",
  F979: "Nuoro",
  G088: "Oristano",
  G224: "Padova",
  G273: "Palermo",
  G337: "Parma",
  G388: "Pavia",
  G453: "Pesaro",
  G482: "Pescara",
  G478: "Perugia",
  G535: "Piacenza",
  G702: "Pisa",
  G713: "Pistoia",
  G888: "Pordenone",
  G942: "Potenza",
  G999: "Prato",
  H163: "Ragusa",
  H199: "Ravenna",
  H223: "Reggio Emilia",
  H224: "Reggio Calabria",
  H282: "Rieti",
  H294: "Rimini",
  H501: "Roma",
  H620: "Rovigo",
  H703: "Salerno",
  H982: "Sassari (sud)",
  I452: "Sassari",
  I480: "Savona",
  I726: "Siena",
  I754: "Siracusa",
  I829: "Sondrio",
  L049: "Taranto",
  L103: "Teramo",
  L117: "Terni",
  L219: "Torino",
  L331: "Trapani",
  L378: "Trento",
  L407: "Treviso",
  L424: "Trieste",
  L483: "Udine",
  L682: "Varese",
  L736: "Venezia",
  L746: "Verbania",
  L750: "Vercelli",
  L781: "Verona",
  L840: "Vicenza",
  M082: "Viterbo",
};

// ──────────────────────────────────────────────────────────────────────────
//  Stati esteri – codice Z (ISTAT)
// ──────────────────────────────────────────────────────────────────────────
const STATI_ESTERI = {
  Z100: "Albania",
  Z101: "Andorra",
  Z102: "Austria",
  Z103: "Belgio",
  Z104: "Bulgaria",
  Z106: "Danimarca",
  Z107: "Finlandia",
  Z108: "Francia",
  Z109: "Germania",
  Z110: "Gran Bretagna",
  Z111: "Grecia",
  Z112: "Irlanda",
  Z113: "Islanda",
  Z115: "Liechtenstein",
  Z116: "Lussemburgo",
  Z117: "Malta",
  Z118: "Monaco",
  Z119: "Norvegia",
  Z120: "Paesi Bassi",
  Z121: "Polonia",
  Z122: "Portogallo",
  Z123: "Romania",
  Z124: "San Marino",
  Z125: "Spagna",
  Z126: "Svezia",
  Z127: "Svizzera",
  Z128: "Turchia",
  Z129: "Ungheria",
  Z131: "Città del Vaticano",
  Z133: "Estonia",
  Z134: "Lettonia",
  Z135: "Lituania",
  Z136: "Moldavia",
  Z137: "Russia",
  Z138: "Ucraina",
  Z139: "Bielorussia",
  Z140: "Slovenia",
  Z141: "Croazia",
  Z142: "Bosnia-Erzegovina",
  Z143: "Macedonia del Nord",
  Z144: "Serbia",
  Z145: "Montenegro",
  Z146: "Kosovo",
  Z147: "Repubblica Ceca",
  Z148: "Slovacchia",
  Z149: "Cipro",
  Z200: "Argentina",
  Z201: "Bolivia",
  Z202: "Brasile",
  Z203: "Canada",
  Z204: "Cile",
  Z205: "Colombia",
  Z206: "Costa Rica",
  Z207: "Cuba",
  Z208: "Ecuador",
  Z209: "El Salvador",
  Z210: "Guatemala",
  Z211: "Haiti",
  Z212: "Honduras",
  Z213: "Messico",
  Z214: "Nicaragua",
  Z215: "Panama",
  Z216: "Paraguay",
  Z217: "Perù",
  Z218: "Repubblica Dominicana",
  Z219: "Stati Uniti d'America",
  Z220: "Uruguay",
  Z221: "Venezuela",
  Z223: "Afghanistan",
  Z224: "Arabia Saudita",
  Z225: "Myanmar (Birmania)",
  Z226: "Cambogia",
  Z227: "Cina",
  Z230: "Corea del Nord",
  Z231: "Corea del Sud",
  Z232: "Giappone",
  Z233: "Giordania",
  Z234: "India",
  Z235: "Indonesia",
  Z236: "Iran",
  Z237: "Iraq",
  Z238: "Israele",
  Z239: "Libano",
  Z240: "Pakistan",
  Z241: "Filippine",
  Z242: "Siria",
  Z243: "Tailandia",
  Z244: "Vietnam",
  Z245: "Yemen",
  Z246: "Cina (Taiwan)",
  Z247: "Bangladesh",
  Z248: "Sri Lanka",
  Z249: "Nepal",
  Z301: "Algeria",
  Z302: "Egitto",
  Z303: "Etiopia",
  Z304: "Ghana",
  Z305: "Kenya",
  Z306: "Libia",
  Z307: "Madagascar",
  Z308: "Marocco",
  Z309: "Mozambico",
  Z310: "Nigeria",
  Z311: "Sudafrica",
  Z312: "Senegal",
  Z313: "Somalia",
  Z314: "Sudan",
  Z315: "Tanzania",
  Z316: "Tunisia",
  Z317: "Uganda",
  Z318: "Congo (Rep. Dem.)",
  Z319: "Eritrea",
  Z320: "Camerun",
  Z321: "Costa d'Avorio",
  Z322: "Angola",
  Z401: "Australia",
  Z402: "Nuova Zelanda",
};

// ──────────────────────────────────────────────────────────────────────────
//  Funzione principale di validazione del codice di controllo
// ──────────────────────────────────────────────────────────────────────────
export function validateCodiceFiscale(cf) {
  if (!cf || cf.length !== 16) {
    return {
      valid: false,
      reason: "Il codice fiscale deve essere di 16 caratteri",
    };
  }

  const upper = cf.toUpperCase();
  const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;
  if (!cfRegex.test(upper)) {
    return {
      valid: false,
      reason: "Il formato del codice fiscale non è valido",
    };
  }

  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const ch = upper[i];
    sum += i % 2 === 0 ? (ODD_VALUES[ch] ?? 0) : (EVEN_VALUES[ch] ?? 0);
  }

  const expected = String.fromCharCode("A".charCodeAt(0) + (sum % 26));
  if (upper[15] !== expected) {
    return {
      valid: false,
      reason: `Carattere di controllo non valido (atteso: ${expected}, trovato: ${upper[15]})`,
    };
  }

  return { valid: true };
}

// ──────────────────────────────────────────────────────────────────────────
//  Funzione principale di decodifica
// ──────────────────────────────────────────────────────────────────────────
export function decodeCodiceFiscale(cf) {
  if (!cf || cf.length !== 16) return null;

  const upper = cf.toUpperCase();

  // --- Sesso e giorno di nascita ---
  const rawDay = parseInt(upper.substring(9, 11), 10);
  const gender = rawDay > 40 ? "Femmina" : "Maschio";
  const day = rawDay > 40 ? rawDay - 40 : rawDay;

  // --- Mese ---
  const monthLetter = upper[8];
  const monthName = MESI[monthLetter] || "Sconosciuto";

  // --- Anno ---
  const yearShort = parseInt(upper.substring(6, 8), 10);
  const currentYear = new Date().getFullYear();
  const century = yearShort <= currentYear % 100 ? 2000 : 1900;
  const birthYear = century + yearShort;

  // --- Luogo di nascita ---
  const belfioreCode = upper.substring(11, 15);
  let birthPlace;
  if (belfioreCode.startsWith("Z")) {
    const stateLabel = STATI_ESTERI[belfioreCode];
    birthPlace = stateLabel
      ? `${stateLabel} (cittadino straniero)`
      : `Stato estero (codice: ${belfioreCode})`;
  } else {
    birthPlace =
      COMUNI[belfioreCode] || `Comune con codice Belfiore ${belfioreCode}`;
  }

  // --- Età ---
  const today = new Date();
  const birthDate = new Date(
    birthYear,
    Object.keys(MESI).indexOf(monthLetter),
    day,
  );
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasBirthdayPassed =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() >= birthDate.getDate());
  if (!hasBirthdayPassed) age -= 1;

  return {
    gender,
    day,
    monthName,
    birthYear,
    birthPlace,
    belfioreCode,
    birthDateFormatted: `${String(day).padStart(2, "0")} ${monthName} ${birthYear}`,
    age: age >= 0 ? age : null,
    isForeign: belfioreCode.startsWith("Z"),
  };
}
